import { createBrowserRouter } from "react-router-dom";
import Main from "../layout/Main";
import Home from "../components/Home/Home";
import Skills from "../components/Skills/Skills";
import Contact from "../components/Contact/Contact";
import Blog from "../components/Blog/Blog";
import AboutMore from "../components/AboutMore/AboutMore";
import MoreProjects from "../components/MoreProjects/MoreProjects";
import ProjectsDetails from "../components/ProjectsDetails/ProjectsDetails";
import ErrorPage from "../components/ErrorPage/ErrorPage";

export const router = createBrowserRouter([
    {
        path: '/',
        element: <Main></Main>,
        children: [
            {
                path : '/',
                element : <Home></Home>
            },
            {
                path : 'skills',
                element: <Skills></Skills>
            },
            {
                path : 'blog',
                element: <Blog></Blog>
            },
            {
                path : 'projects',
                element: <MoreProjects></MoreProjects>
            },
            {
                path : 'projects/:id',
                loader: ({params})=>fetch(`https://shakil-server.vercel.app/projects/${params.id}`), 
                element: <ProjectsDetails></ProjectsDetails>
            },
            {
                path : 'about',
                element: <AboutMore></AboutMore>
            },
            {
                path : 'contact',
                element: <Contact></Contact>
            },
            {
                path : '*',
                element : <ErrorPage></ErrorPage>
            }
        ]
    }
])